export default "skymp5-front/f144c6d6f30321ddb756c1f8b8ca5f1b.png";